import React, { useState } from 'react';
import { View, Text, Pressable } from 'react-native';

const RadioButton = (props) => {
    const [userOption, setUserOption] = useState(props.initValue);

    const itemStyleHandler = (item) => {
        if(item.mode == userOption && item.mode == 0) return styles.selectedSun
        if(item.mode != userOption && item.mode == 0) return styles.unselectedSun
        if(item.mode == userOption && item.mode == 1) return styles.selectedSnow
        if(item.mode != userOption && item.mode == 1) return styles.unselectedSnow 

    }

    return (
    <View>
        {props.data.map((item) => {
        return (
            <Pressable
                style={itemStyleHandler(item)}

                onPress={() => {
                    props.onChange(item.mode)
                }}
            >

                <Text style={styles.option}> {item.value}</Text>
            </Pressable>
        );
        })}
    </View>
    );
}

let styles = {
    option: {
        fontSize: 20,
        color: 'white',
        textAlign: 'center',
      },
      unselectedSnow: {
        marginTop: 2,
        borderRadius: 5,
        backgroundColor: '#394b81',
        alignItems: 'center'

    },
      selectedSnow: {
        marginTop: 2,
        padding: 10,
        borderRadius: 5,
        backgroundColor:'#000f9f',
        alignItems: 'center'
      },
      unselectedSun: {
        marginBottom: 2,
        borderRadius: 5,
        backgroundColor: '#9e3e3e',
        alignItems: 'center'
      },
      selectedSun: {
        marginBottom: 2,
        padding: 10,
        borderRadius: 5,
        backgroundColor: '#d30000',
        alignItems: 'center'
      },
}

export default RadioButton;